<script>

import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { attributeService } from "../../services";
import draggable from "vuedraggable";
import { debounce,success_message,error_message } from "../../Helper/helper";

export default {
  components: { Layout, PageHeader, pagination, attributeService, draggable },
    data() {
        const { status,attribute_type,orderBy,sortBy} = this.$route.query;
        return {
            title: this.trans.get('__JSON__.Attributes'),
            url: null,
            debounce: false,
            items: [],
            checked: true,
            sortBy: sortBy || "id",
            sortDesc: orderBy && orderBy != '' ? true : orderBy,
            loading: true,
            paginations: {},
            limit: 1,
            search: "",
            attributeCount: "",
            status: status == undefined ? '1' :status,
            config: config,
            attribute_type: attribute_type == undefined ? 'material' :attribute_type,
            fieldBox:[
                'id','att_name','price','type','action'
            ],
            searchData:debounce(()=>{
                if(!this.init){
                    const {status,attribute_type,orderBy,sortBy} = this.$data;
                    this.$router.replace({name: 'attribute-list', query: {status,attribute_type,orderBy,sortBy}})
                }
                this.getAttributeList();
                this.init = false;
            },500),
            
            fields: [
                { key: "id", label: "#", sortable: false ,thClass:"dis-event"},
                { key: "att_name", label: "Name", sortable: true },
                { key: "price", label: "Price", sortable: true },
                { key: "type", label: "Type", sortable: false,thClass:"dis-event" },
                { key: "action", label: "Action", sortable: false,thClass:"dis-event" },
            ],
        };
    },
    mounted() {
        this.getAttributeList();
    },
    computed:{
        computedFields(){
            if (this.attribute_type != 'box'){
                var valObj = this.fields.filter(function(field) {
                    if (field.key != 'price') return field;
                });
                return valObj;
            }
            else return this.fields;
        },
    },
    methods: {
        sortingChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getAttributeList();
        },
        getAttributeList(page) {
            this.loading = true;
            attributeService
            .getAttributeList({ 
                search: this.search,
                status: this.status,
                attribute_type: this.attribute_type,
                sortBy: this.sortBy,
                orderBy: this.sortDesc ? "desc" : "asc",
                page: page && page > 0 ? page : 1,
            })
            .then((response) => {
                this.loading = false;
                this.paginations = response.data.result;
                this.items = response.data.result.data;
                this.attributeCount = response.data.result.data.length;
            });
        },
        deleteAttribute(id,type){
            if(confirm("Do you really want to delete?")){
                attributeService.deleteAttribute({id:id, type:type})
                .then(response => {
                    if (response.data.code === 200) {
                        this.getAttributeList();
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        }
    },
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                    <div class="page-title-left">
                        <div class="avatar-xs mr-3">
                        <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                            <i class="bx bx-user-circle"></i>
                        </span>
                        </div>
                        <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Attributes') }}({{attributeCount}})</h4>
                    </div>
                    <div class="page-title-right d-flex">
                        <router-link v-if="$auth.hasPermission(config.permissions.attribute_write)" :to="{name: 'attribute-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
                            <i class="mdi mdi-plus mr-1"></i>
                            {{ trans.get('__JSON__.Add Attribute') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row list-table-main">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-sm-2 offset-8">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Arrtibute Type') }} :</label>
                                        <select class="custom-select" v-model="attribute_type" @change="searchData()">
                                            <option value="bottle">{{ trans.get('__JSON__.Bottle Deposit Price') }}</option>
                                            <option value="box">{{ trans.get('__JSON__.Box Deposit Price') }}</option>
                                            <option value="material" selected>{{ trans.get('__JSON__.Material') }}</option>
                                            <option value="size">{{ trans.get('__JSON__.Size') }}</option>
                                            <option value="tax">{{ trans.get('__JSON__.Tax') }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="col-sm-2">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Status') }} :</label>
                                        <select class="custom-select" v-model="status" @change="searchData()">
                                            <option value="">{{ trans.get('__JSON__.All') }}</option>
                                            <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                                            <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-sm-2">
                                <div class="date-range-list">
                                    <label>{{ trans.get('__JSON__.Search') }} :</label>
                                    <div class="text-sm-right">
                                        <div class="search-box mr-2 d-inline-block">
                                            <div class="position-relative">
                                                <input
                                                type="text"
                                                class="form-control"
                                                id="search"
                                                @input="searchData()"
                                                v-model="search"
                                                :placeholder="trans.get('__JSON__.Search Placeholder')"
                                                />
                                                <i class="bx bx-search-alt search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 table-main-list attribute-table table-responsive">
                                <b-table
                                :items="items"
                                :fields="computedFields"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                                @sort-changed="sortingChanged"
                                :busy="loading"
                                show-empty
                                >
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                                    </div>
                                </template>

                                <template v-slot:cell(id)="data">
                                    <h5 class="font-size-14">{{ data.item.id }}</h5>
                                </template>

                                <template v-slot:cell(att_name)="data">
                                    <h5 class="font-size-14">{{ data.item.att_name }}</h5>
                                </template>

                                <template v-slot:cell(type)="data">
                                    <span>{{ data.item.type }}</span>
                                </template>

                                <!-- <template v-slot:cell(status)="data">
                                    <div
                                    v-if="data.item.status === '0'"
                                    class="badge badge-pill badge-soft-danger font-size-12"
                                    >{{ trans.get('__JSON__.Inactive') }}</div>
                                    <div
                                    v-else
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    >{{ trans.get('__JSON__.Active') }}</div>
                                </template> -->

                                <template v-slot:cell(action)="data">
                                    <router-link
                                    :to="{name: 'attribute-edit',params: { id:base64(data.item.id), type:data.item.type}}"
                                    class="btn btn-success btn-sm btn-rounded"
                                    >Edit</router-link>

                                    <button
                                        type="submit"
                                        @click="deleteAttribute(base64(data.item.id),data.item.type)"
                                        class="btn btn-danger btn-sm btn-rounded ml-1"
                                    >{{ trans.get('__JSON__.Delete') }}</button>
                                </template>

                                <template #empty>
                                    <p class="text-center">{{ trans.get('__JSON__.No Attribute Found') }}</p>
                                </template>
                                </b-table>
                            </div>
                            <div class="row col-sm-5 offset-sm-7">
                                <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                        <pagination
                                            :data="paginations"
                                            :limit="limit"
                                            @pagination-change-page="getAttributeList"
                                        ></pagination>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
/* .attribute-table .table thead th:nth-child(1),.attribute-table .table thead th:nth-child(3),.attribute-table .table thead th:nth-child(4),.attribute-table .table thead th:nth-child(5){
  pointer-events: none;
} */
</style>